import {Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {map, Observable} from "rxjs";
import {CitizensServices} from "../../../../../store/entities/citizens/citizens-services/citizens-services.model";
import {PageResult} from "../../../../../store/base.graphql";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../../store/reducers";
import {PaginationService} from "../../../../../services/pagination.service";
import {
  selectModifiedCitizensService
} from "../../../../../store/entities/citizens/citizens-services/citizens-services.selectors";
import {
  citizenGetServices,
  clearCitizensServicess
} from "../../../../../store/entities/citizens/citizens-services/citizens-services.actions";

@Component({
  selector: 'app-shared-portal-services-list',
  templateUrl: './shared-portal-services-list.component.html',
  styleUrl: './shared-portal-services-list.component.scss'
})
export class SharedPortalServicesListComponent implements OnInit {
  citizenServices$: Observable<CitizensServices[]>
  filteredCitizenServices$: Observable<CitizensServices[]>;
  pageObject: PageResult
  @Input() from: string
  @Input() uniqueId: string
  @Input() hideBackButton: boolean;
  @Output() paginate = new EventEmitter<any>();
  @Output() searchKeyWord = new EventEmitter<any>();
  showFilter = false;
  @ContentChild(TemplateRef, {static: true}) banner: TemplateRef<any>;


  constructor(
    private store: Store<AppState>,
    private paginationService: PaginationService
  ) {
    this.store.dispatch(clearCitizensServicess());
  }

  ngOnInit() {
    this.citizenServices$ = this.store.select(selectModifiedCitizensService).pipe(map(data => {
      if (data) {
        this.pageObject = this.paginationService.getPage()
      }
      return data;
    }))
    this.filteredCitizenServices$ = this.citizenServices$;
  }

  loadNextData(pageable) {
    this.paginate.emit(pageable);
  }

  searchData(searchTerm: string) {
    this.searchKeyWord.emit(searchTerm);
  }


}
